import { RouteObject } from 'react-router-dom';
import { FeatureSliderManager } from './employers-managment/feature-slider-manager';
import { FeaturePlansManager } from './configurations/feature-plans-manager';
import { FeatureBlogsManager } from './blogs-managment/feature-blogs-manager';
// /admin/plans/index
export const ADMIN_ROUTES: RouteObject[] = [
   {
      path: '/admin/users/selectforslider',
      Component: FeatureSliderManager,
   },
   {
      path: '/admin/manage-plans',
      Component: FeaturePlansManager,
   },
   {
      path: '/admin/blogs',
      Component: FeatureBlogsManager,
   },
];
